import { ADULTS, CHILDREN, DEFAULT_OCCUPANCY } from 'components/NumberOfGuests/constants';
import {
	CRUISE_DATES_FILTER,
	DEPARTURE_PORT_FILTER,
	DESTINATION_FILTER,
	DESTINATION_PORT,
	DESTINATION_REGION,
	NIGHTS_FILTER,
	NUMBER_OF_GUESTS_FILTER_KEY,
	SHIP_FILTER,
	VOYAGE_TYPE_FILTER,
} from './constants';
import { CalendarType, FilterDropdownConfig } from './types';

export const FILTERS: Array<FilterDropdownConfig> = [
	{
		label: CRUISE_DATES_FILTER.label,
		key: CRUISE_DATES_FILTER.key,
		tabs: [
			{
				filterOwner: CRUISE_DATES_FILTER.key,
				value: CalendarType.Months,
				dictionaryLabel: 'labelSelectByMonths',
				testId: 'search-by-months-toggle-button',
			},
			{
				filterOwner: CRUISE_DATES_FILTER.key,
				value: CalendarType.Dates,
				dictionaryLabel: 'labelSelectByDates',
				testId: 'search-by-dates-toggle-button',
			},
		],
		desktopTestId: 'date-filter-button',
		dictionaryLabel: CRUISE_DATES_FILTER.dictionaryLabel,
		amount: 0,
		isFullColor: false,
		mobileTestId: 'mobile-date-filter-button',
		isSelected: false,
		dictionarySubLabel: CRUISE_DATES_FILTER.dictionarySubLabel,
	},
	{
		label: DESTINATION_FILTER.label,
		key: DESTINATION_FILTER.key,
		tabs: [
			{
				filterOwner: DESTINATION_FILTER.key,
				value: DESTINATION_REGION,
				dictionaryLabel: 'labelSelectByRegions',
				testId: 'search-by-regions-toggle-button',
			},
			{
				filterOwner: DESTINATION_PORT,
				value: DESTINATION_PORT,
				dictionaryLabel: 'labelSelectByPorts',
				testId: 'search-by-ports-toggle-button',
				dictionarySubLabel: 'labelAllPorts',
			},
		],
		desktopTestId: 'destination-filter-button',
		dictionaryLabel: DESTINATION_FILTER.dictionaryLabel,
		mobileTestId: 'mobile-destination-filter-button',
		amount: 0,
		isFullColor: false,
		isSelected: false,
		dictionarySubLabel: DESTINATION_FILTER.dictionarySubLabel,
	},
	{
		label: DEPARTURE_PORT_FILTER.label,
		key: DEPARTURE_PORT_FILTER.key,
		desktopTestId: 'departure-port-filter-button',
		mobileTestId: 'mobile-departure-port-filter-button',
		dictionaryLabel: DEPARTURE_PORT_FILTER.dictionaryLabel,
		amount: 0,
		isFullColor: false,
		isSelected: false,
		dictionarySubLabel: DEPARTURE_PORT_FILTER.dictionarySubLabel,
	},
	{
		label: NIGHTS_FILTER.label,
		key: NIGHTS_FILTER.key,
		desktopTestId: 'number-of-nights-filter-button',
		mobileTestId: 'mobile-number-of-nights-filter-button',
		dictionaryLabel: NIGHTS_FILTER.dictionaryLabel,
		amount: 0,
		isFullColor: false,
		isSelected: false,
		dictionarySubLabel: NIGHTS_FILTER.dictionarySubLabel,
	},
	{
		label: SHIP_FILTER.label,
		key: SHIP_FILTER.key,
		mobileTestId: 'mobile-ship-filter-button',
		dictionaryLabel: SHIP_FILTER.dictionaryLabel,
		amount: 0,
		isFullColor: false,
		desktopTestId: 'ship-filter-button',
		isSelected: false,
		dictionarySubLabel: SHIP_FILTER.dictionarySubLabel,
	},
	{
		label: VOYAGE_TYPE_FILTER.label,
		key: VOYAGE_TYPE_FILTER.key,
		mobileTestId: 'mobile-cruise-type-filter-button',
		dictionaryLabel: VOYAGE_TYPE_FILTER.dictionaryLabel,
		amount: 0,
		isFullColor: false,
		desktopTestId: 'cruise-type-filter-button',
		isSelected: false,
		dictionarySubLabel: VOYAGE_TYPE_FILTER.dictionarySubLabel,
	},
];

export const HOME_FILTERS: Array<FilterDropdownConfig> = [
	{
		key: 'startDate',
		tabs: [
			{
				filterOwner: CRUISE_DATES_FILTER.key,
				value: CalendarType.Months,
				dictionaryLabel: 'labelSelectByMonths',
				testId: 'search-by-months-toggle-button',
			},
			{
				filterOwner: CRUISE_DATES_FILTER.key,
				value: CalendarType.Dates,
				dictionaryLabel: 'labelSelectByDates',
				testId: 'search-by-dates-toggle-button',
			},
		],
		desktopTestId: 'widget-date-filter-button',
		label: 'Any dates',
		dictionaryLabel: 'homeNavCruiseDates',
		dictionaryTopLabel: 'homeNavTopCruiseDates',
		dictionarySubLabel: '',
		dictionaryModalLabel: 'navCruiseDates',
		amount: 0,
		isFullColor: false,
		isSelected: false,
	},
	{
		key: 'destination',
		tabs: [
			{
				filterOwner: DESTINATION_FILTER.key,
				value: DESTINATION_REGION,
				dictionaryLabel: 'labelSelectByRegions',
				testId: 'search-by-regions-toggle-button',
			},
			{
				filterOwner: DESTINATION_PORT,
				value: DESTINATION_PORT,
				dictionaryLabel: 'labelSelectByPorts',
				testId: 'search-by-ports-toggle-button',
				dictionarySubLabel: 'labelAllPorts',
			},
		],
		desktopTestId: 'widget-destination-filter-button',
		label: 'Anywhere',
		dictionaryLabel: 'homeNavDestination',
		dictionaryTopLabel: 'homeNavTopDestination',
		dictionarySubLabel: 'labelAllDestinations',
		dictionaryModalLabel: 'navDestination',
		amount: 0,
		isFullColor: false,
		isSelected: false,
	},
	{
		key: 'departurePort',
		desktopTestId: 'widget-departure-port-filter-button',
		label: 'Any ports',
		dictionaryLabel: 'homeNavDeparturePort',
		dictionaryTopLabel: 'homeNavTopDeparturePort',
		dictionarySubLabel: 'labelAllDestinations',
		dictionaryModalLabel: 'navDeparturePort',
		amount: 0,
		isFullColor: false,
		isSelected: false,
	},
	{
		label: 'Number of Nights',
		key: 'nights',
		dictionaryLabel: 'homeNavNights',
		dictionaryTopLabel: 'homeNavTopNights',
		dictionarySubLabel: 'labelLengthOfCruise',
		dictionaryModalLabel: 'navNights',
		desktopTestId: 'widget-number-of-nights-filter-button',
		amount: 0,
		isFullColor: false,
		isSelected: false,
	},
	{
		label: 'Ships',
		key: 'ship',
		dictionaryLabel: 'homeNavShips',
		dictionaryTopLabel: 'homeNavTopShips',
		dictionarySubLabel: 'labelAllOurShips',
		dictionaryModalLabel: 'navShips',
		desktopTestId: 'widget-ship-filter-button',
		amount: 0,
		isFullColor: false,
		isSelected: false,
	},
];

export const BASE_NUMBER_OF_GUESTS_FILTER: FilterDropdownConfig = {
	label: 'Number of guests',
	key: NUMBER_OF_GUESTS_FILTER_KEY,
	dictionaryLabel: 'navNumberOfGuests',
	dictionaryTopLabel: '',
	dictionarySubLabel: '',
	dictionaryModalLabel: 'navNumberOfGuests',
	desktopTestId: 'number-of-guests-filter-button',
	mobileTestId: 'mobile-number-of-guests-filter-button',
	amount: 0,
	isFullColor: false,
	isSelected: false,
};

export const NUMBER_OF_GUESTS_FILTER: FilterDropdownConfig = {
	label: 'Number of guests',
	key: NUMBER_OF_GUESTS_FILTER_KEY,
	dictionaryLabel: 'homeNavNumberOfGuests',
	dictionaryTopLabel: 'homeNavTopNumberOfGuests',
	dictionarySubLabel: '',
	dictionaryModalLabel: '',
	desktopTestId: 'widget-number-of-guests-filter-button',
	mobileTestId: 'mobile-number-of-guests-filter-button',
	amount: 0,
	isFullColor: false,
	isSelected: false,
	skipModal: true,
};

export const ADULTS_FILTER_OPTION = {
	key: ADULTS,
	type: 'OcupancyFilter',
	label: '',
	isEnabled: true,
	options: [
		{
			code: DEFAULT_OCCUPANCY.adults.toString(),
			label: ADULTS,
			isDisabled: false,
			isSelected: false,
		},
	],
};

export const CHILDREN_FILTER_OPTION = {
	key: CHILDREN,
	type: 'OcupancyFilter',
	label: '',
	isEnabled: true,
	options: [
		{
			code: DEFAULT_OCCUPANCY.children.toString(),
			label: CHILDREN,
			isDisabled: false,
			isSelected: false,
		},
	],
};
